import { MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { PageShell } from "../../components/PageShell/PageShell";
import { StaticPageMeta } from "../../components/PageMeta/PageMeta";
import { Button } from "../../components/ui/button";
import { siteGraphJsonLd, webPageJsonLd } from "../../lib/jsonLd";
import { STATIC_PAGE_META } from "../../lib/staticPageMeta";
import { MainContentSection } from "./sections/MainContentSection/MainContentSection";

export const ElementLight = (): JSX.Element => {
  const home = STATIC_PAGE_META.home;

  return (
    <PageShell>
      <StaticPageMeta
        meta={home}
        jsonLd={[
          siteGraphJsonLd(),
          webPageJsonLd({
            path: home.path,
            title: home.title,
            description: home.description,
          }),
        ]}
      />
      <main className="flex flex-col w-full">
        <MainContentSection />
      </main>

      <Button
        asChild
        className="fixed bottom-4 right-4 md:bottom-5 md:right-5 w-14 h-14 md:w-[60px] md:h-[60px] p-0 rounded-full bg-wwwuxmichalcomdodger-blue hover:bg-blue-600 transition-colors duration-200 shadow-lg hover:shadow-xl flex items-center justify-center z-40 text-white"
        aria-label="Contact Michal"
      >
        <Link to="/contact">
          <MessageCircle className="w-7 h-7" strokeWidth={2} aria-hidden />
        </Link>
      </Button>
    </PageShell>
  );
};
